var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page-title-header"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("全系統設定")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrganizationModuleList'
      }
    }
  }, [_vm._v("全模組列表")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isReadOnly ? "檢視模組" : _vm.isEditing ? '編輯模組' : '新增模組'))])], 1)], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.isReadOnly ? "檢視模組" : _vm.isEditing ? '編輯模組' : '新增模組'))]), _c('div', {
    staticClass: "mb-2"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "設定類型",
      "label-for": "merchant"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tableOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.table,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "table", $$v);
      },
      expression: "form.table"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.table.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "代碼"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.key.$error') ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.key,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "key", $$v);
      },
      expression: "form.key"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.key.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "資料類型"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.typeOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分類"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.category.$error') ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.category,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "category", $$v);
      },
      expression: "form.category"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "名稱"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.name.$error') ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.name.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "內容描述"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "rows": "5",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "系統方案代碼"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.target.$error') ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.target,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "target", $$v);
      },
      expression: "form.target"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "內容"
    }
  }, [_c('JsonEditor', {
    attrs: {
      "height": "64px"
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "設定檔"
    }
  }, [_c('JsonEditor', {
    attrs: {
      "height": "64px"
    },
    model: {
      value: _vm.form.config,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "config", $$v);
      },
      expression: "form.config"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "順序"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.order.$error') ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.order,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "order", $$v);
      },
      expression: "form.order"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.order.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")]) : _vm._e()], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }